// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3b0700d4","669":"e4af9a29","787":"4faddade"}[chunkId] + ".chunk.js";
};